import { useCallback, useState } from 'react'

interface ConversationNotification {
  readonly open: boolean
  readonly message: string
  readonly severity: 'success' | 'error' | 'warning' | 'info'
}

interface UseConversationNotificationsReturn {
  readonly notification: ConversationNotification
  readonly showSuccess: (message: string) => void
  readonly showError: (message: string) => void
  readonly showWarning: (message: string) => void
  readonly showInfo: (message: string) => void
  readonly close: () => void
}

export function useConversationNotifications(): UseConversationNotificationsReturn {
  const [notification, setNotification] = useState<ConversationNotification>({
    open: false,
    message: '',
    severity: 'success',
  })

  const showSuccess = useCallback((message: string) => {
    setNotification({
      open: true,
      message,
      severity: 'success',
    })
  }, [])

  const showError = useCallback((message: string) => {
    setNotification({
      open: true,
      message,
      severity: 'error',
    })
  }, [])

  const showWarning = useCallback((message: string) => {
    setNotification({
      open: true,
      message,
      severity: 'warning',
    })
  }, [])

  const showInfo = useCallback((message: string) => {
    setNotification({
      open: true,
      message,
      severity: 'info',
    })
  }, [])

  const close = useCallback(() => {
    setNotification((prev) => ({
      ...prev,
      open: false,
    }))
  }, [])

  return {
    notification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    close,
  }
}
